// Generated by ReScript, PLEASE EDIT WITH CARE

import * as AppStorage from "../../utils/AppStorage.bs.jsx";
import * as InputToggle from "../InputToggle/InputToggle.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";
import InputThrustDeviceModuleCss from "./InputThrustDevice.module.css";

let classes = InputThrustDeviceModuleCss;

function InputThrustDevice(props) {
  let match = AppStorage.useLocalStorage(AppStorage.keyThrustDevice);
  let setThrustDevice = match[1];
  return <div
    className={classes.root}
  >
    <div>
      <label
        htmlFor={"thrust_device"}
      >
        {`Důvěřovat tomuto zařízení`}
      </label>
      <p>
        {`Aplikace pak funguje i bez internetu.`}
      </p>
    </div>
    <InputToggle.make
      checked={match[0] !== undefined}
      id={"thrust_device"}
      name={"thrust_device"}
      onChange={event => {
        let target = event.target;
        let checked = target.checked;
        setThrustDevice(checked ? `1` : undefined);
      }}
    />
  </div>;
}

let make = InputThrustDevice;

export {
  classes,
  make,
}
/* classes Not a pure module */
